import React from 'react';
import { ToastContainer, Toast, Modal, Button } from 'react-bootstrap';
import Preloader from './../components/Preloader';
import RunningProcessIcon from "./../assets/running_icon.svg";
import FinishProcessIcon from "./../assets/finish_icon.svg";
import GeneralApi from "./../services/openapi/api/GeneralApi.js"
import LkApi from "./../services/openapi/api/LkApi.js"

import ChainIcon from "./../assets/chain_icon.svg"
import TableIcon from './../assets/table_icon.svg'
import MapIcon from './../assets/map_icon.svg'
import DecomposerIcon from "./../assets/decomposerIcon.svg"
import NormaliserIcon from "./../assets/normaliserIcon.svg"
import GeometryIcon from "./../assets/geometryIcon.svg"
import MetadataIcon from "./../assets/metadata_icon.svg"
import ImportIcon from './../assets/import_icon.svg';



import * as actionTypes from "./../services/StoreContainer/actionTypes";

class BaseActionForm extends React.Component {

    ALERT_TIME_TO_LIVE = 5000;
    ALERT_CHECK_INTERVAL = 1000;

    constructor(props) {
        super(props);

        this.generalApi = new GeneralApi();
        this.lkApi = new LkApi();

        this.state = {
            ...this.state,
            alerts: [],
            loading: false
        }
    }

    componentDidMount() {
        this.alertTimer = setInterval(() => {
            if (this.state && this.state.alerts.length > 0) {
                let alerts = this.state.alerts.filter((alert) => (Date.now() - alert.start < this.ALERT_TIME_TO_LIVE));
                this.setState({ alerts: alerts });
            }
        }, this.ALERT_CHECK_INTERVAL);
    }

    addAlert = (response) => {
        let alertText = JSON.stringify(response, null, 4);

        if (response.hasOwnProperty('insertedId')) {
            alertText = "Добавлена запись с _id=" + response.insertedId;
        }
        else
            if (response.hasOwnProperty('modifiedCount')) {
                alertText = "Изменена " + response.modifiedCount + " запись";
            }
            else
                if (response.hasOwnProperty('deletedCount')) {
                    alertText = "Удалена " + response.deletedCount + " запись";
                }
                else
                    if (response.hasOwnProperty('errorMessageRu')) {
                        alertText = response.errorMessageRu;
                    }

        let alerts = this.state.alerts.slice();
        alerts.push({
            text: alertText,
            start: Date.now()
        });
        this.setState({ alerts: alerts });
    }

    removeAlert = (alert) => {
        let alerts = this.state.alerts.slice();
        alerts.splice(this.state.alerts.indexOf(alert), 1);
        this.setState({ alerts: alerts });
    }

    checkStatus = (response) => {
        return true;

        if (Object.prototype.toString.call(response) !== '[object Array]') {
            response = [response];
        }
        let success = true;
        let errors = [];
        response.forEach((item) => {
            if (item) {
                success = success && (item.status === "success");
                if (item.status !== "success") {
                    errors.push(item);
                }
            }
        });
        if (!success) {
            errors.forEach((item) => {
                console.log(item);
            });
        }
        return success;
    }

    startLoading = () => {
        this.setState({ loading: true });
    }

    stopLoading = () => {
        this.setState({ loading: false });
    }

    renderAlerts() {
        if (this.state.alerts && (this.state.alerts.length > 0)) {
            return (
                <ToastContainer position="top-end" className="p-3" style={{ zIndex: 10 }}>
                    {this.state.alerts.map((item, index) =>
                        <Toast key={index} onClose={() => { this.removeAlert(item) }}>
                            <Toast.Header>
                                <strong className="me-auto">Изменение состояния</strong>
                                <small className="text-muted">только что</small>
                            </Toast.Header>
                            <Toast.Body>{item.text}</Toast.Body>
                        </Toast>
                    )}
                </ToastContainer>
            );
        }
    }

    renderConfirmationWindow(header, text, buttons, handler) {
        return (
            <Modal show={this.state.getDeleteConfirmation} onHide={() => { this.handleDeleteConfirmation(false); }}>
                <Modal.Header closeButton>
                    <Modal.Title>{header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{text}</Modal.Body>
                <Modal.Footer>
                    {buttons.map((button, index) => (
                        <Button key={index} variant={button.variant || "secondary"} onClick={() => { handler(button.value); }}>
                            {button.label}
                        </Button>
                    ))}
                </Modal.Footer>
            </Modal>

        );
    }

    renderPreloader() {
        return (this.state.loading ? <Preloader /> : null);
    }

    goToSection = (navigation, section, params = null) => {
        // if (this.props.navigateTo) {
        //     this.props.navigateTo(section, params);
        // }

        console.log('/lk/' + section);

        navigation('/lk/' + section, { state: { params } })
    }

    sectionName = (type) => {
        switch (type) {
            case actionTypes.CONNECTOR:
                return 'связать с ОАП';
            case actionTypes.DECOMPOSER:
                return 'разобрать адреса';
            case actionTypes.NORMALISER:
                return 'нормализовать адреса';
            case actionTypes.GEOMETRY_TRANSFORMER:
                return 'обработать геометрию';
            case actionTypes.PUBLISHER:
                return 'опубликовать на карту';
            case actionTypes.IMPORT_DATASET:
                return 'добавить файл';
            case actionTypes.GEOMETRY_EDITOR:
                return 'редактировать геометрию';
            case actionTypes.MASS_UPDATE:
                return 'массовое заполнение';
            case actionTypes.TUNE_METADATA:
                return 'настроить структуру';
            case actionTypes.DATASET_TABLE:
                return 'посмотреть таблицу';
            case actionTypes.MY_TARIF:
                return 'мой тариф';
        }
    }

    sectionIcon = (type) => {
        switch (type) {
            case actionTypes.CONNECTOR:
                return ChainIcon;
            case actionTypes.DECOMPOSER:
                return DecomposerIcon;
            case actionTypes.NORMALISER:
                return NormaliserIcon;
            case actionTypes.GEOMETRY_TRANSFORMER:
                return GeometryIcon;
            case actionTypes.PUBLISHER:
                return MapIcon;
            case actionTypes.IMPORT_DATASET:
                return ImportIcon;
            case actionTypes.GEOMETRY_EDITOR:
                return null;
            case actionTypes.MASS_UPDATE:
                return null;
            case actionTypes.TUNE_METADATA:
                return MetadataIcon;
            case actionTypes.DATASET_TABLE:
                return TableIcon;
        }
    }

    getOperationsList = () => {
        return [
            { field: "any", type: actionTypes.TUNE_METADATA, anotherPage: "TuneMetadata" },
            { field: "decomposer", type: actionTypes.DECOMPOSER },
            { field: "normaliser", type: actionTypes.NORMALISER },
            { field: "connector", type: actionTypes.CONNECTOR },
            { field: "publisher", type: actionTypes.PUBLISHER },
            { field: "geometryTransformer", type: actionTypes.GEOMETRY_TRANSFORMER },
            { field: "importDataset", type: actionTypes.IMPORT_DATASET },
            { field: "any", type: actionTypes.DATASET_TABLE, anotherPage: "DatasetTable" },
        ];
    }

    getPropertiesForButtonsList = (dataset) => {
        let result = {
            decomposer: false,
            normaliser: false,
            connector: false,
            publisher: false,
            importDataset: false,
            geometryTransformer: false,
            nothing: false,
        }
        if (dataset && dataset.state && dataset.state.properties) {

            // временная мера, пусть всегда будет доступна
            //if (!dataset.state.properties.has_address && (true || dataset.state.properties.has_address_features)) {
            result.decomposer = true
            //}
            result.decomposerNotify = (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_decomposer")))) ? RunningProcessIcon : undefined;

            if (dataset.state.properties.has_address) {
                result.normaliser = true
            }
            result.normaliserNotify = (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_normalizer")))) ? RunningProcessIcon : undefined;

            // временная мера, пусть всегда будет доступна
            //if (!dataset.state.properties.connected && (dataset.state.properties.has_geometry || dataset.state.properties.has_address)){
            result.connector = true
            //}

            result.connectorNotify = (dataset.connect && (dataset.connect.stage === "readyToCheck")) ? FinishProcessIcon :
                (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_connector")))) ? RunningProcessIcon : undefined;

            if (dataset.state.properties.has_geometry) {
                result.publisher = true;
            }
            result.publisherNotify = (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_publisher")))) ? RunningProcessIcon : undefined;

            //временная мера
            let hasXFeature = dataset.fields.find((field) => (field.feature === "x"));
            let hasYFeature = dataset.fields.find((field) => (field.feature === "y"));
            if (!dataset.state.properties.has_geometry && (dataset.state.properties.has_geometry_features || (hasXFeature && hasYFeature))) {
                result.geometryTransformer = true
            }
            result.geometryTransformerNotify = (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_geometrytransformer")))) ? RunningProcessIcon : undefined;

            result.exporterNotify = (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_exporter")))) ? RunningProcessIcon : undefined;

            result.importDataset = true

            result.importDatasetNotify = (dataset.runningTasks && (dataset.runningTasks.find((task) => (task.performer === "lk_importer")))) ? RunningProcessIcon : undefined;
        }
        else {
            result.nothing = true
        }
        return result
    }

    isAtLeastOneDatasetProcessRunning = (dataset) => {
        const buttonsLine = this.getPropertiesForButtonsList(dataset);
        return (buttonsLine.connectorNotify !== undefined ||
            buttonsLine.normaliserNotify !== undefined ||
            buttonsLine.decomposerNotify !== undefined ||
            buttonsLine.geometryTransformerNotify !== undefined ||
            buttonsLine.publisherNotify !== undefined ||
            buttonsLine.importDatasetNotify !== undefined);
    }
}

export default BaseActionForm;